import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipe',
    pure: false
})
export class FilterPipePipe implements PipeTransform {
    transform(items: any[], filter: string): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }
}



// WEBPACK FOOTER //
// /app/src/app/pipes/filter-pipe/filter-pipe.pipe.ts